module.exports = __webpack_public_path__ + "img/icon-public-transport.d1801147.svg";